import SalePage from "repoV2/pages/sale/SalePage";

export default SalePage;
